function FourOFour() {
  return (
    <div className="error-page">
      <img
        src="https://cdn.dribbble.com/users/2764945/screenshots/5521737/hello_still_2x.gif?compress=1&resize=400x300"
        alt="error"
      ></img>
      <h1>Error!!!! Page Not Found, Sorry.</h1>
    </div>
  );
}



// function FourOFour() {
//     return <div>ERROR!!!!!</div>;
//   }
  
  export default FourOFour;